module.exports = {"title":"Login","loginSocial":"Sign in using one of your existing accounts:","loginRegular":"Or use your Username/password:","loginGoogle":"Login with Google","username":"Username","password":"Password","passwordTooltip":"The password you will use to log into ShowTix4U. This user will have full access to all areas of the site.","login":"Login","loggedOut":"You have successfully been logged out.","forgotUsername":"Forgot your username?","forgotPassword":"Forgot your password?"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/LoginForm/locales/en.json
// module id = 1368
// module chunks = 0